import { z } from 'zod';
export const permanentFeatureFlagsSchema = z.object({
    unityMessaging: z.boolean().default(false),
    tumAccessRules: z.boolean().default(false),
    showAutoFixButton: z.boolean().default(false),
    enableCoachesTeamForAllCoaches: z.boolean().default(false),
    enableAxleEventDebug: z.boolean().default(false),
    enablePublishDebug: z.boolean().default(false),
    grantAdminAccess: z.boolean().default(false),
    showWorkoutSupportButton: z.boolean().default(false),
    disableActualsCollectionFlag: z.boolean().default(false),
    amsSyncDebugEnabled: z.boolean().default(false),
    bowlingBlockTypeFlag: z.boolean().default(false),
    enableSyncLogsFlag: z.boolean().default(false),
    updateWorkoutLogFlag: z.boolean().default(false),
    showAdditionalTeamsFlag: z.boolean().default(false),
    zeroDebugFlag: z.boolean().default(false),
    crossBlockBowlingOverlayFlag: z.boolean().default(false),
    developerToolsFlag: z.boolean().default(false),
    hubEventsOnCalendarFlag: z.boolean().default(false),
    mavenSupportChatFlag: z.boolean().default(false),
    incomingStatusFlag: z.boolean().default(false),
    digitalDisplaysFlag: z.boolean().default(false),
});
export const temporaryFeatureFlagsSchema = z.object({
    zeroFlag: z.boolean().default(false),
    tracksZeroFlag: z.boolean().default(false),
    planZeroFlag: z.boolean().default(false),
    actualsZeroFlag: z.boolean().default(false),
    blockBuilderZeroFlag: z.boolean().default(false),
    publishPrintZeroFlag: z.boolean().default(false),
    tabletZeroFlag: z.boolean().default(false),
    aiFlag: z.boolean().default(false),
    workoutImporterFlag: z.boolean().default(false),
    dragInteractionsFlag: z.boolean().default(false),
    gamificationEventsFlag: z.boolean().default(false),
    subTrackReorganizationFlag: z.boolean().default(false),
});
export const featureFlagsSchema = z.object({
    ...permanentFeatureFlagsSchema.shape,
    ...temporaryFeatureFlagsSchema.shape,
});
export function getCommercialDefaultFlags() {
    return featureFlagsSchema.parse({});
}
export function getGovDefaultFlags(environment) {
    return featureFlagsSchema.parse({
        tumAccessRules: true,
        // for demoing H2F
        enableCoachesTeamForAllCoaches: environment === 'staging',
        grantAdminAccess: true,
        // Metacal isn't launched in Gov
        hubEventsOnCalendarFlag: false,
        zeroFlag: environment === 'staging',
        gamificationEventsFlag: true,
    });
}
//# sourceMappingURL=flags.js.map